import { GraphQLClient } from 'graphql-request'
import { getSdk } from './gql'

const client = new GraphQLClient('/query')
export const sdk = getSdk(client)
